import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {NeighborhoodProps} from '../types';
import {CreateNeighborhoodProps} from './use-create-neighborhood';
import neighborhoodsKeys from '../util/neighborhoods-keys';
import citiesKeys from 'modules/cities/util/cities-keys';
import {useNavigate} from 'react-router-dom';

export interface EditNeighborhoodProps
  extends Omit<CreateNeighborhoodProps, 'id' | 'city'> {
  cityId: string;
}

const useEditNeighborhood = (
  neighborhoodId: string,
  goToCitiesModule?: boolean,
) => {
  const {update} = useInfiniteQueryHelpers();
  const queryHelpers = useQueryHelpers();
  const navigate = useNavigate();

  const onSuccess = (data: NeighborhoodProps) => {
    update(neighborhoodsKeys.list(), data);
    queryHelpers.setData(neighborhoodsKeys.details(neighborhoodId), data);

    const cityNeighborhoods = queryHelpers.getData(
      citiesKeys.neighborhoods(data.cityId),
    );

    if (cityNeighborhoods)
      queryHelpers.update(citiesKeys.neighborhoods(data.cityId), data);

    if (goToCitiesModule) navigate(-1);
  };

  return useApiMutation<EditNeighborhoodProps>({
    url: `/neighborhoods/${neighborhoodId}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar bairro',
    successTitle: 'Editar bairro',
    successMessage: 'Bairro atualizado com sucesso',
    onSuccess,
  });
};

export default useEditNeighborhood;
